
import { Mesh, Program, Plane } from 'ogl'

import vertex from './shaders/gradient/vertex.glsl'
import fragment from './shaders/gradient/fragment.glsl'

export default class Gradient {
  constructor({ gl, scene }) {
    this.gl = gl
    this.scene = scene

    //Methods    
    this.createGeometry()
    this.createProgram()
    this.createMesh()
  }

  createGeometry() {
    this.geometry = new Plane(this.gl, {
      width: window.innerWidth,
      height: window.innerHeight,
      widthSegments: 10,
      heightSegments: 10
    })

  }

  createProgram() {

    this.program = new Program(this.gl, {
      vertex,
      fragment,
      uniforms: {
        uTime: { value: 0 },
        uRed: { value: 0.293 },
        uGreen: { value: 0.337 },
        uBlue: { value: 0.783 }
      },

      transparent: true,
      cullFace: null
    })
  }

  createMesh() {
    this.mesh = new Mesh(this.gl, {
      geometry: this.geometry,
      program: this.program
    })

    this.mesh.setParent(this.scene)
  }

  onResize(viewport) {
    this.mesh.scale.x = viewport.width
    this.mesh.scale.y = viewport.height
  }

  update(time) {
    //Time
    this.mesh && (this.mesh.program.uniforms.uTime.value = time)
  }

}